import { Box } from "@biblioteksentralen/react";
import { CordataSearchWorksResponse } from "@biblioteksentralen/bmdb-search-client";
import { VisuallyHiddenResults } from "../../../components/VisuallyHiddenResults";
import { useTranslation } from "../../../utils/hooks/useTranslation";
import { SeeMoreResultsButton } from "./SeeMoreResultsButton";
import { useSearchContext } from "./SearchContext";
import ItemGrid from "../works/ItemGrid";
import { CordataWork } from "@libry-content/integrations";
import { usePaginateAndFocusIndex } from "../../../utils/hooks/usePaginateAndFocusIndex";

type Props = {
  works: CordataSearchWorksResponse["results"];
  endOfResults: boolean;
  isValidating: boolean;
  paginate: () => void;
};

const WorksList = ({ works, endOfResults, isValidating, paginate }: Props) => {
  const { t } = useTranslation();

  const { paginateAndFocus, autoFocusIndex } = usePaginateAndFocusIndex({ paginate, list: works });

  const { searchState } = useSearchContext();

  const getSelectedCategoryLabel = () => {
    switch (searchState?.selectedCategory) {
      case "book":
        return works.length > 1 ? t("Bøker") : t("Bok");
      case "videogame":
        return t("Spill");
      case "movie":
        return works.length > 1 ? t("Filmer") : t("Film");
      case "music":
        return t("Musikkverk");
      default:
        return works.length > 1 ? t("Materialer") : t("Materiale");
    }
  };

  if (works.length === 0) return null;

  const cordataWorks = works.map(
    ({ work, representativeManifestationId }) => new CordataWork(work, representativeManifestationId)
  );

  return (
    <Box>
      <VisuallyHiddenResults itemsLength={works.length} name={getSelectedCategoryLabel().toLowerCase()} />
      <ItemGrid items={cordataWorks} headingSize="h2" autoFocusIndex={autoFocusIndex} />
      {!endOfResults && <SeeMoreResultsButton marginTop="4rem" loading={isValidating} onClick={paginateAndFocus} />}
    </Box>
  );
};

export default WorksList;
